<template>
  <qx-card-form title="证件信息" v-show="showComponent" :defaultContentShow="false">
    <span slot="titleLeft" class="notices error" v-if="isAddDrivingLicenseDateShow" style="margin-left: 10px">注意：行驶证证照信息和行驶证失效日期，需在车辆年审内维护</span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <div slot="cutting" class="cutting"></div>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import { getBigImg } from '@qx/utils/index';
import {
  getVehicleLicense,
} from 'api/car';
import {
  getFileUrl,
} from 'api';
const aImgName = ['drivingLicenseList', 'adriverLicenseCopyList', 'gasificationCertificateList', 'specialOperCertFileIdList'];

export default {
  data () {
    return {
      isEEnergyType: false,
      showComponent: true,
      // 是否显示【行驶证注册时间】数据维护提示
      isAddDrivingLicenseDateShow: false,
      drivingLicenseInfo: {},
      otherFormData: {},
      baseForm: {
        inline: true,
        form: [
          {
            label: '行驶证正本',
            value: 'drivingLicenseList',
            type: 'img',
            accept: 'image/*',
            valueWidth: '240px',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
            hide: false,
            onChange: async (arr) => {
              let loading = this.$loading();
              // 获取原图（原图才能识别，缩略图识别不了）
              const drivingLicenseInfo = await getVehicleLicense({ url: getBigImg(arr[0].url) });
              loading.close();
              if (!drivingLicenseInfo) {
                return;
              }
              if (drivingLicenseInfo.plateNumber) {
                this.$refs.baseForm.setVal('plateNumber', drivingLicenseInfo.plateNumber);
              }
              if (drivingLicenseInfo.issueDate) {
                this.$refs.baseForm.setVal('vehicleValidityTime', drivingLicenseInfo.issueDate);
              }
              if (drivingLicenseInfo.owner) {
                this.$refs.baseForm.setVal('drivingLicenseOwner', drivingLicenseInfo.owner);
              }
              if (drivingLicenseInfo.registrationDate) {
                this.$refs.baseForm.setVal('drivingLicenseDate', drivingLicenseInfo.registrationDate);
              }
              this.drivingLicenseInfo = drivingLicenseInfo;
              this.$emit('drivingLicenseInfo', drivingLicenseInfo);
            },
            onRemove: () => {
              // 删除图片之后，对应的图片数据也删除掉
              const plateNumber = this.$refs.baseForm.getVal('plateNumber');
              const owner = this.$refs.baseForm.getVal('drivingLicenseOwner');
              const registrationDate = this.$refs.baseForm.getVal('drivingLicenseDate');
              if (plateNumber === this.drivingLicenseInfo.plateNumber) {
                this.$refs.baseForm.setVal('plateNumber', '');
              }
              if (owner === this.drivingLicenseInfo.owner) {
                this.$refs.baseForm.setVal('drivingLicenseOwner', '');
              }
              if (registrationDate === this.drivingLicenseInfo.registrationDate) {
                this.$refs.baseForm.setVal('drivingLicenseDate', '');
              }
              this.drivingLicenseInfo = {};
              this.$emit('drivingLicenseInfo', this.drivingLicenseInfo);
            },
          },
          {
            label: '行驶证副本',
            value: 'adriverLicenseCopyList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
            hide: false,
          },
          {
            label: '加气证',
            value: 'gasificationCertificateList',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            hide: true,
          },
          // 外调车显示 特殊运营者
          {
            label: '特殊运营证',
            value: 'specialOperCertFileIdList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
            hide: true,
          },

          {
            label: '',
            value: 'cutting',
            class: 'cutting',
            slot: true,
          },
          {
            label: '行驶证上所有人',
            value: 'drivingLicenseOwner',
            type: 'input',
            hide: false,
          },
          {
            label: '行驶证注册日期',
            value: 'drivingLicenseDate',
            type: 'date',
            hide: false,
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '行驶证失效日期',
            value: 'vehicleValidityTime',
            type: 'date',
            hide: false,
            attr: {
              time: '00:00:00',
            },
            disabled: false,
          },
          {
            label: '行驶证失效日期',
            value: 'isAddDrivingLicenseDate',
            allCustom: true,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    setIsEEnergyType (isEEnergyType) {
      this.isEEnergyType = isEEnergyType;
      // 如果是天然气类型车辆
      if (this.isEEnergyType) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: [
            'gasificationCertificateList',
          ],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: [
            'gasificationCertificateList',
          ],
        });
      }

    },
    setBaseForm (mode) {
      if (mode === 'my') {
        // 自有车模式要显示的
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: [
            'drivingLicenseOwner', 'drivingLicenseDate', 'vehicleValidityTime', 'drivingLicenseList', 'adriverLicenseCopyList',
          ],
        });

        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['specialOperCertFileIdList'],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: [
            'drivingLicenseOwner', 'drivingLicenseList', 'adriverLicenseCopyList', 'specialOperCertFileIdList',
          ],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: [
            'drivingLicenseDate', 'vehicleValidityTime',
          ],
        });
      }
      this.showComponent = true;
    },
    async getDataTest () {
      this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 讲需要提交的图片字段放进 formData 对象里面
        for (let imgItem of aImgName) {
          // 获取要提交的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
          const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
          // 如果 drivingLicenseList 数组里面有图片，则将数组里面的图片id 赋值给 drivingLicense，用于提交和缓存数据
          if (formData[imgItem] && formData[imgItem].length) {
            formData[imgField] = formData[imgItem][0].id;
            formData[imgField + 'Url'] = formData[imgItem][0].url;
          } else {
            formData[imgField] = '';
            formData[imgField + 'Url'] = '';
          }
        }

        formData.drivingLicenseDate = formData.drivingLicenseDate ? this.formatDate(formData.drivingLicenseDate) : '';

        formData.vehicleValidityTime = formData.vehicleValidityTime ? this.formatDate(formData.vehicleValidityTime) : '';

        formData = {
          ...formData,
          ...this.otherFormData,
        };

        delete formData.adriverLicenseCopyList;
        delete formData.drivingLicenseList;
        delete formData.gasificationCertificateList;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.specialOperCertFileIdList;
      }
      // console.log('行驶证信息提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm(data);
      if (data.vehicleValidityTime) {
        this.isAddDrivingLicenseDateShow = true;
      } else {
        this.isAddDrivingLicenseDateShow = false;
      }
      let flowIds = [];
      for (let imgItem of aImgName) {
        // 获取详情接口返回的的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
        const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
        // 例如 drivingLicense 有图片id值，代表有图片，传图片id到另外一个接口获取图片url
        if (data[imgField]) {
          flowIds.push(data[imgField]);
        } else {
          // 如果没有数据，则设置为空数组，防止报错
          data[imgItem] = [];
        }
      }
      if (flowIds.length) {
        const imgRes = await getFileUrl({
          flowIds: flowIds.join(),
        });
        for (let imgItem of aImgName) {
          const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
          imgRes.items.forEach((item) => {
            if (`${item.flowId}` === `${data[imgField]}`) {
              if (data[imgField]) {
                data[imgItem + 'Url'] = item.fullPath;
                data[imgItem] = [{
                  id: `${item.flowId}`,
                  url: item.fullPath,
                }];
              }
            }
          });
        }
      }

      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.showComponent = false;
      this.setBaseForm('outward');
    },
    resetToNormal () {
      // 恢复成正常模式
      this.showComponent = true;
      this.setBaseForm('my');
    },
    // 设置所有表单
    resetBaseForm (data) {
      if (this.$route.query.type === 'my') {
        // 隐藏除了【基础信息】和【车辆参数】之外的其他模块
        this.setBaseForm('my');
      } else {
        this.setBaseForm('outward');
      }
      if (data !== undefined && data.vehicleValidityTime) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['vehicleValidityTime'],
        });
      }
      if (data !== undefined && data.drivingLicense) {
        // 如果有详情或者操作缓存返回id，也就是代表有图片，则要设置
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['drivingLicenseList'],
        });
      }
      if (data !== undefined && data.adriverLicenseCopy) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['adriverLicenseCopyList'],
        });
      }
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      if (this.$route.query.type === 'my') {
        if (vehicleInfo) {
          // 有注册信息，而且是新增模式下，隐藏组件
          if (!this.$route.query.id) {
            this.showComponent = false;
          }
        } else {
          // 没注册信息，显示组件
          this.showComponent = true;
        }
      }
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .cutting {
  display: block;
  margin-bottom: 0;
}
</style>
